import React from 'react';
import { ChallengeButton } from 'components/atoms/Buttons/ChallengeButton';
import { Modal } from 'components/organisms/Modals/Modal';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import { ChallengeLotsBlock } from 'components/molecules/Blocks/ChallengeLotsBlock';
import { ChallengeBanner } from 'components/atoms/Widgets/ChallengeBanner';
import { IconLabel } from 'components/atoms/Texts/IconLabel';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import emojis from 'theme/emoji';
import useStyle from './challengeModal.style';
import { useQuery } from '@apollo/client';
import FrontError from '../../../../helpers/errors/front.error';
import { QueryUserClasseQuery } from '../../../../graphql/generated/graphql';
import { formatDate, getDaysAndHoursLeft } from 'helpers/date/formatDate';
import { challengeRulesLink } from 'helpers/challenge';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { QUERY_USER_CLASSE } from '../../../../graphql/query/user/queryUserAccount';
import { useMediaQuery } from 'hooks/useMediaQuery';
import { CURRENT_CHALLENGE_YEAR } from 'helpers/challenge/getChallengeInfos';

interface ChallengeModalProps {
  variant: 'default' | 'autumn' | 'spring';
  buttonModal?: 'default' | 'leaderboard';
}

export const ChallengeModal = ({
  variant,
  buttonModal = 'default'
}: ChallengeModalProps) => {
  const classes = useStyle();
  const year = CURRENT_CHALLENGE_YEAR;
  const isMobile = useMediaQuery('mobile');
  const queryDatesChallenge = useQuery<QueryUserClasseQuery>(QUERY_USER_CLASSE);
  if (queryDatesChallenge.loading)
    return buttonModal === 'default' ? (
      <ChallengeButton onClick={null} variant={variant} year={year} />
    ) : (
      <ButtonWithText
        variant={'text'}
        content={!isMobile ? 'Voir les lots à gagner' : 'Lots'}
        icon={'Gift'}
        iconColor={'#959595'}
        iconSize="small"
        onClick={null}
      />
    );

  if (queryDatesChallenge.error)
    return (
      <Modal
        modalHead="Actu Challenge"
        triggerButton={
          buttonModal === 'default' ? (
            <ChallengeButton
              isMobileTopBar={isMobile}
              onClick={null}
              variant={variant}
              year={year}
            />
          ) : (
            <ButtonWithText
              variant={'text'}
              content={!isMobile ? 'Voir les lots à gagner' : 'Lots'}
              icon={'Gift'}
              iconColor={'#959595'}
              iconSize="small"
              onClick={null}
            />
          )
        }
        triggerButtonStyle="ChallengeModal"
        width={'medium'}
      >
        <ChallengeBanner season={variant} year={year} />
        <div className={classes.content}>
          <ErrorContainer
            detailErr={
              new FrontError(
                'ChallengeModal :récupération des dates du challenge',
                queryDatesChallenge.error
              )
            }
            text={"Veuillez recharger l'affichage"}
            setFeedback
          />
        </div>
      </Modal>
    );

  const textDatesChallenge = () => {
    return queryDatesChallenge
      ? `Du ${formatDate(
          queryDatesChallenge.data.getUserClasse.debut
        )} au ${formatDate(queryDatesChallenge.data.getUserClasse.fin)} inclus`
      : 'Pas de challenge en cours';
  };

  const textTempsRestant = () => {
    return queryDatesChallenge
      ? getDaysAndHoursLeft(queryDatesChallenge.data.getUserClasse.fin)
      : 'Terminé';
  };

  return (
    <Modal
      modalHead="Actu Challenge"
      triggerButton={
        buttonModal === 'default' ? (
          <ChallengeButton
            isMobileTopBar={isMobile}
            onClick={null}
            variant={variant}
            year={year}
          />
        ) : (
          <ButtonWithText
            variant={'text'}
            content={!isMobile ? 'Voir les lots à gagner' : 'Lots'}
            icon={'Gift'}
            iconColor={'#959595'}
            iconSize="small"
            onClick={null}
          />
        )
      }
      triggerButtonStyle="ChallengeModal"
      width={'medium'}
    >
      <ChallengeBanner season={variant} year={year} />
      <div className={classes.content}>
        <div className={classes.desc}>
          <div className={classes.labelsList}>
            <IconLabel
              withoutMargin={true}
              icon="Users"
              label=" + 7000 participants"
            />
            <IconLabel
              withoutMargin={true}
              icon="Clock"
              label={textTempsRestant()}
            />
            <IconLabel
              withoutMargin={true}
              icon="Calendar"
              label={textDatesChallenge()}
            />
          </div>
          <div>
            <div className={classes.buttonsList}>
              <ButtonWithText
                variant="primaryGreen"
                content="Présentation de la notation"
                onClick={() =>
                  window.open(challengeRulesLink.notation, '_blank')
                }
              />
              <ButtonWithText
                variant="primaryGreen"
                content="Règlement"
                onClick={() =>
                  window.open(challengeRulesLink.reglement, '_blank')
                }
              />
            </div>
          </div>
        </div>

        <HeaderText text="Liste des lots" emoji={emojis['Gift']} />
        <div className={classes.lotsList}>
          <ChallengeLotsBlock
            headerText="iPhone 17"
            imageSource="iphone"
            descriptionText="Pour le premier élève-vendeur au national"
          />
          <ChallengeLotsBlock
            headerText="Airpods pro"
            imageSource="airpodspro"
            descriptionText="Pour le premier élève-vendeur de chaque niveau"
          />
          <ChallengeLotsBlock
            headerText="Airpods"
            imageSource="airpods"
            descriptionText="Pour le premier élève-vendeur de chaque académie"
          />
          <ChallengeLotsBlock
            headerText="Cartes cadeaux"
            imageSource="cartecadeau"
            descriptionText="Pour le premier élève-vendeur de chaque classe"
          />
        </div>
        <p>
          Voir conditions dans le{' '}
          <a
            href={challengeRulesLink.reglement}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.reglementLink}
          >
            règlement du challenge
          </a>
        </p>
      </div>
    </Modal>
  );
};
